import React from 'react';

export { AlertContainer, alert } from './Alert';

export { Avatar } from './Avatar';
export { DropZone, useDropzone, type FileWithPath } from './DropZone';
export { LinkRenderer } from './LinkRenderer';
export { NetworkStatusChecker } from './NetworkStatusChecker';
export { AuthFormNotification } from './AuthFormNotification';
export { Note } from './Note';
export { Switch } from './Switch';
export { Skeleton } from '@aspid/ui';

import { FileRendererSkeleton } from './FileRenderer/FileRendererSkeleton';
import { SpreadSheetSkeleton } from './SpreadSheet/SpreadSheetSkeleton';

import type { FileRendererProperties } from './FileRenderer';
import type { SpreadSheetOptions } from './SpreadSheet';

const SpreadSheetLazy = React.lazy(() => import('./SpreadSheet'));
const FileRendererLazy = React.lazy(() => import('./FileRenderer'));

export const SpreadSheet = (properties: SpreadSheetOptions) => (
  <React.Suspense fallback={<SpreadSheetSkeleton />}>
    <SpreadSheetLazy {...properties} />
  </React.Suspense>
);

export const FileRenderer = <T,>(properties: FileRendererProperties<T>) => (
  <React.Suspense fallback={<FileRendererSkeleton />}>
    <FileRendererLazy {...properties} />
  </React.Suspense>
);
